import React, { useEffect } from "react";
import "antd/dist/antd.css";
import { Button, PageHeader, Breadcrumb, Card } from "antd";
import { EditFilled } from "@ant-design/icons";
import { getApis, updateApi } from "../../actions/setting";
import { Link } from "react-router-dom";
import { useState } from "react";
import { connect } from "react-redux";
import { Content } from "antd/lib/layout/layout";

import ModalForms from "./modalForms";


const ApiListN = ({ getApis, updateApi }) => {
  const [data, setData] = useState([]);

  const [visible1, setVisible1] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [visible3, setVisible3] = useState(false);
  const [visible4, setVisible4] = useState(false);
  const [visible5, setVisible5] = useState(false);
  const [visible6, setVisible6] = useState(false);
  const [visible7, setVisible7] = useState(false);


  const Refresh = async () => {
    const res = await getApis();
    setData(res);
   
  };

  async function fetchData() {
    const res = await getApis();
    setData(res);
  }
  useEffect(() => {
    fetchData();
  }, []);


  return (
    <Content>
      <Breadcrumb style={{ padding: "10px 0px" }}>
        <Breadcrumb.Item>
          <Link to="/dashboard">Home</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>API</Breadcrumb.Item>
      </Breadcrumb>
      <PageHeader
        ghost={false}
        onBack={() => window.history.back()}
        title="API"
        subTitle="Setting Management"
      ></PageHeader>

      <Card title="Tokens nad keys">
        <Card
          type="inner"
          title="EMAIL SENDER TOKEN"
          extra={
            <Button
              icon={<EditFilled />}
              type="primary"
              onClick={() => {
                setVisible1(true);
              }}
            >
              Edit
            </Button>
          }
        >
          <span style={{ backgroundColor: "#e6e6e6", padding: "5px" }}>
            {data?.email_token}
          </span>
        </Card>

        <Card
          type="inner"
          title="EMAIL SENDER ID"
          extra={
            <Button
              icon={<EditFilled />}
              type="primary"
              onClick={() => {
                setVisible2(true);
              }}
            >
              Edit
            </Button>
          }
        >
          <span style={{ backgroundColor: "#e6e6e6", padding: "5px" }}>
            {data?.email_sender_id}
          </span>
        </Card>

        <Card
          type="inner"
          title="SMS TOKEN"
          extra={
            <Button
              icon={<EditFilled />}
              type="primary"
              onClick={() => {
                setVisible3(true);
              }}
            >
              Edit
            </Button>
          }
        >
          <span style={{ backgroundColor: "#e6e6e6", padding: "5px" }}>
            {data?.sms_token}
          </span>
        </Card>

        <Card
          type="inner"
          title="SMS SENDER ID"
          extra={
            <Button
              icon={<EditFilled />}
              type="primary"
              onClick={() => {
                setVisible4(true);
              }}
            >
              Edit
            </Button>
          }
        >
          <span style={{ backgroundColor: "#e6e6e6", padding: "5px" }}>
            {data?.sms_sender_id}
          </span>
        </Card>

        <Card
          type="inner"
          title="SCAN LIMIT"
          extra={
            <Button
              icon={<EditFilled />}
              type="primary"
              onClick={() => {
                setVisible5(true);
              }}
            >
              Edit
            </Button>
          }
        >
          <span style={{ backgroundColor: "#e6e6e6", padding: "5px" }}>
            {data?.scan_limit}
          </span>
        </Card>

        <Card
          type="inner"
          title="APP VERSION LEVEL"
          extra={
            <Button
              icon={<EditFilled />}
              type="primary"
              onClick={() => {
                setVisible6(true);
              }}
            >
              Edit
            </Button>
          }
        >
          <span style={{ backgroundColor: "#e6e6e6", padding: "5px" }}>
            {data?.app_version_level}
          </span>
        </Card>

        <Card
          type="inner"
          title="APP VERSION CODE"
          extra={
            <Button
              icon={<EditFilled />}
              type="primary"
              onClick={() => {
                setVisible7(true);
              }}
            >
              Edit
            </Button>
          }
        >
          <span style={{ backgroundColor: "#e6e6e6", padding: "5px" }}>
            {data?.app_version_code}
          </span>
        </Card>
      </Card>

      {/* email sender Token */}
      <ModalForms
        title="Update Email Token"
        visible={visible1}
        cancel={() => setVisible1(false)}
        ok={() => setVisible1(false)}
        api={updateApi}
        refresh={Refresh}
        name="email_token"
        label="EMAIL TOKEN"
      />

      {/* email sender id */}
      <ModalForms
        title="Update Email Sender ID"
        visible={visible2}
        cancel={() => setVisible2(false)}
        ok={() => setVisible2(false)}
        api={updateApi}
        refresh={Refresh}
        name="email_sender_id"
        label="SENDER ID"
      />

      {/* sms token */}
      <ModalForms
        title="Update SMS Token"
        visible={visible3}
        cancel={() => setVisible3(false)}
        ok={() => setVisible3(false)}
        api={updateApi}
        refresh={Refresh}
        name="sms_token"
        label="SMS TOKEN"
      />

      {/* sms sender id */}
      <ModalForms
        title="Update SMS Sender ID"
        visible={visible4}
        cancel={() => setVisible4(false)}
        ok={() => setVisible4(false)}
        api={updateApi}
        refresh={Refresh}
        name="sms_sender_id"
        label="SENDER ID"
      />

      {/* Update Scan Limit */}
      <ModalForms
        title="Update Scan Limit"
        visible={visible5}
        cancel={() => setVisible5(false)}
        ok={() => setVisible5(false)}
        api={updateApi}
        refresh={Refresh}
        name="scan_limit"
        label="SCAN LIMIT"
      />

      {/* version level */}
      <ModalForms
        title="Update App Version Level"
        visible={visible6}
        cancel={() => setVisible6(false)}
        ok={() => setVisible6(false)}
        api={updateApi}
        refresh={Refresh}
        name="app_version_level"
        label="VERSION LEVEL"
        dropdown={true}
      />

      {/* version code */}
      <ModalForms
        title="Update App Version Code"
        visible={visible7}
        cancel={() => setVisible7(false)}
        ok={() => setVisible7(false)}
        api={updateApi}
        refresh={Refresh}
        name="app_version_code"
        label="VERSION CODE"
      />


    </Content>
  );
};
export default connect(null, { getApis, updateApi })(ApiListN);
